import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'

const SvgAlignRight = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M21 10H8m13-4H4m17 8H4m17 4H8"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgAlignRight)
export default ForwardRef
